var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1Parking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17v42h40V17H18zm22.06 27H33v9h-6V23h13.06a10.119 10.119 0 0110.5 10.23A10.93 10.93 0 0140.06 44zm4.77-10.77A4.78 4.78 0 0140.06 38H33V28h7.06a5.53 5.53 0 014.77 5.23z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Parking.12fec743.svg";
export { SvgI1Parking as ReactComponent };